import React from 'react';
import { observable } from 'mobx';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPencilAlt } from '@fortawesome/free-solid-svg-icons';

import { Popconfirm, Popup, Button, Loader } from '@smartplatform/ui';
import store from '../../store';
import './style.scss';

@observer
export default class ImagesNew extends React.Component {
	
	static propTypes = {
		record: PropTypes.object, // запись, к которой прикрепляются картинки
		relation: PropTypes.string, // название реляции к аттачментам
		model: PropTypes.func, // модель аттачмента
		property: PropTypes.string, // свойство аттачмента, в которое пишется файл
		textProperty: PropTypes.string, // свойство аттачмента, в которое пишется название
		getUrl: PropTypes.func, // функция получения url картинки
		disableUpload: PropTypes.bool, // запрет на добавление картинок
	};
	
	static defaultProps = {
		model: store.model.Attachment,
		property: 'filename',
		disableUpload: false,
	};
	
	@observable images = [];
	@observable editImage = null;
	@observable isUploading = false;

	constructor(props) {
		super(props);
		this.record = props.record;
		this.getUrl = props.getUrl || function(image) {return image.downloadFile(props.property)};
		this.init();
	}
	
	init = async () => {
		this.images = await this.record[this.props.relation]({ order: 'id desc' });
		console.log('images', this.images);
	};
	
	handleFileProgress = event => {
		// console.log('handleFileProgress', event);
	};
	
	onDrop = async (accepted, rejected) => {
		console.log('onDrop', accepted, rejected);
		this.isUploading = true;
		for (let file of accepted) {
			const attachment = new this.props.model();
			attachment[this.props.property] = file.name;
			await attachment.save();
			try {
				const res = await this.upload(attachment, file);
				console.log('uploaded', attachment.id, res);
				if (res.ok) {
					await this.record[this.props.relation].add(attachment.id);
					this.images = [attachment, ...this.images];
				}
			}
			catch (e) {
				console.warn(e);
			}
		}
		this.isUploading = false;
	};
	
	upload = (attachment, file) => new Promise((resolve, reject) => {
		attachment.uploadFile('filename', file)
			.on('progress', this.handleFileProgress)
			.end((error, result) => {
				if (!error) {
					resolve(result);
				} else {
					reject(error);
				}
			});
	});
	
	edit = image => {
		this.editImage = image;
	};
	
	onNameChange = e => {
		this.editImage[this.props.textProperty] = e.target.value;
	};
	
	submit = async () => {
		await this.editImage.save();
		this.editImage = null;
	};
	
	delete = async image => {
		const index = this.images.findIndex(_image => _image.id === image.id);
		this.images.splice(index, 1);
		await this.record[this.props.relation].remove(image.id);
		await image.deleteFile('filename');
		await image.delete();
	};
	
	render() {
		const { textProperty, disableUpload } = this.props;
		
		const images = this.images.map(image => {
			const url = this.getUrl(image);
			return <div className="image" key={image.id}>
				<div className="img">
					<a target="_blank" href={url}>
						<img src={url} width={200} height={140} alt="" />
					</a>
				</div>
				<div className="info">
					<div className="edit">
						{textProperty && <FontAwesomeIcon icon={faPencilAlt} className="edit-btn" onClick={() => this.edit(image)} />}
						<Popconfirm onConfirm={() => this.delete(image)} content="Удалить?">
							<FontAwesomeIcon icon={faTrash} className="edit-btn" />
						</Popconfirm>
					</div>
					{textProperty && <div className="title">{image[textProperty] || 'без названия'}</div>}
				</div>
			</div>;
		});
		
		return <div className="gallery-images">
			{!disableUpload && <>
				{!this.isUploading ?
					<Dropzone onDrop={this.onDrop} className="images-dropzone" accept="image/jpeg, image/png">
						Нажмите, чтобы загрузить,<br />
						или перетащите сюда изображения
					</Dropzone>
					:
					<div className="uploading"><Loader /> Идет загрузка...</div>
				}
			</>}
			<div className="images">
				{images}
			</div>
			{this.editImage && <Popup width={340} height={130} header="Подпись к изображению" onClose={() => this.editImage = null}>
				<textarea
					value={this.editImage[this.props.textProperty] || ''}
					onChange={this.onNameChange}
					cols={40}
					rows={5}
					ref={el => el && el.focus()}
				/>
				<Button onClick={this.submit} className="btn-primary">Сохранить</Button>
			</Popup>}
		</div>;
	}
	
}
